import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const getAllReferencesAPI = async (payload) => {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }
    return await axios.get(`${apiBaseUrl}/get-all-reference`,
        { headers }
    )
}


export const createReferenceAPI = async (payload) => {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }
    return await axios.post(`${apiBaseUrl}/create-reference`, payload,
        { headers }
    )
}

export const updateReferenceAPI = async (payload) => {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }
    return await axios.post(`${apiBaseUrl}/update-reference`, payload,
        { headers }
    )
}



export const viewRefFilesAPI = async (payload) => {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }
    return await axios.post(`${apiBaseUrl}/view-reference-file`,payload,
        { headers }
    )
}


export const uploadRefFilesAPI = async (payload) => {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }
    return await axios.post(`${apiBaseUrl}/upload-refernce-Files`, payload,
        { headers }
    )
}

export const downloadReferenceAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: apiToken,
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/downloadReferenceMaster`,
    {
      headers,
      responseType: "blob", 
    }
  )
}